import { Injectable } from '@angular/core';
import { AngularFireDatabase } from '@angular/fire/database';

@Injectable({
  providedIn: 'root'
})
export class OrderService {

  constructor(private db: AngularFireDatabase) { }

  saveOrder(order: any) {
    return this.db.list('/orders').push(order);
  }

  getOrders() {
    return this.db.list('/orders').valueChanges();
  }

}
